'use strict';
/* global $, angular */

angular.module("app.common").directive('noAnimationNav', function() {
  return function(scope, elem) {
    $("header.menu").addClass('fixed');
  };
});